import React from 'react';
import {sortingKeyLabelMap} from './../../../../../shared/config/app-config';
import * as S from './Sorting.styles';
import {defaultTheme} from '@stencil/build-theme';

import HappyArrowDropIcon from '@stencil/icons/src/HappyArrowDropIcon/HappyArrowDropIcon';

const Sorting = ({
  sortingValue,
  updateSortingCaller,
}: {
  sortingValue: string;
  updateSortingCaller: (actionData: string) => void;
}) => {
  return (
    <>
      <S.HoverTargetWrapperDiv>
        <S.FontBoldSpan>Sort By:</S.FontBoldSpan>
        <S.WrapperSpan>
          {sortingKeyLabelMap[sortingValue]}
          <HappyArrowDropIcon
            width="1rem"
            height="1rem"
            margin="0 0 0 0.5rem"
            fill={defaultTheme.colors.goBrandBlue.base}
          />
        </S.WrapperSpan>
        <S.HiddenDropdownWrapperDiv>
          <S.TopDiv>
            <S.ListDropDownWrapper>
              <li>
                <S.FontBoldSpan>Sort By</S.FontBoldSpan>
              </li>
              {Object.keys(sortingKeyLabelMap).map((itemKey, index) => (
                <li
                  key={itemKey + index}
                  onClick={() => {
                    updateSortingCaller(itemKey);
                  }}
                >
                  <S.RadioCheck name={'sortingType'} checked={itemKey === sortingValue} />
                  <S.FontBigBold>{sortingKeyLabelMap[itemKey]}</S.FontBigBold>
                </li>
              ))}
            </S.ListDropDownWrapper>
            <S.TipPositioning />
          </S.TopDiv>
        </S.HiddenDropdownWrapperDiv>
      </S.HoverTargetWrapperDiv>
    </>
  );
};

export default Sorting;
